/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * B book enable disable pair request..
 */
export interface BBookEnableDisablePairRequest {
  pairId: number;
  active: boolean;
}
